export class HttpRetry {
  public hash: number;
  public retries: number;
}
